module.exports = __webpack_public_path__ + "img/3987112_m.9b924fc3.jpg";